import { Branch } from 'components/layout'
import { Members, Member, MemberCreate, MemberDetail, MemberAuditLogs, Invoice, MemberSubscriptions, MemberChangeGroup } from 'components/views/members'
import { Groups, Group, GroupPaymentOptions, GroupCustomFields, Import } from 'components/views/groups'
import { Login, Register, ForgotPassword, ResetPassword, Account, Webhook, Users, User } from 'components/views/account'
import { PaymentOptions, PaymentOption } from 'components/views/membership/payment-options'
import { Taxes, Tax } from 'components/views/membership/taxes'
import { PaymentGateways } from 'components/views/membership'
import { Campaigns, Campaign } from 'components/views/campaigns'
import { Templates, Template, TemplateEditor } from 'components/views/templates'
import L from 'services/Localization'

export default [
  // 404
  { path: '', component: Login, redirect: 'app/members', meta: { hiddenFromNav: true } },
  // No authorized
  { path: '/app/login', name: 'login', component: Login, meta: { authorized: true, hiddenFromNav: true } },
  { path: '/app/forgot-password', name: 'forgot-password', component: ForgotPassword, meta: { authorized: true, hiddenFromNav: true } },
  { path: '/app/reset-password', name: 'reset-password', component: ResetPassword, meta: { authorized: true, hiddenFromNav: true } },
  { path: '/app/register', name: 'register', component: Register, meta: { authorized: true, hiddenFromNav: true } },
  // Dashboard
  // { path: '/dashboard', component: Branch, meta: { label: 'Dashboard', icon: 'dashboard' }, children: [
  //     { path: '', name: 'Dashboard', component: Dashboard },
  //     { name: 'Details', path: 'details', component: Details, meta: { label: 'Details' } } ]
  // },
  // Members
  { path: '/app/members', component: Branch, meta: { label: L.localize('Members_Index_Title'), icon: 'members' }, children: [
      { path: '', name: 'members', component: Members },
      { path: 'create', name: 'member-create', component: MemberCreate, meta: { label: L.localize('Label_Create') } },
      { path: ':id', name: 'member-detail', component: MemberDetail, meta: { label: L.localize('Settings_Breadcrumb_Details') } },
      { path: ':id/edit', name: 'member', component: Member, meta: { label: L.localize('Settings_Breadcrumb_Details') } },
      { path: ':id/change-group', name: 'member-change-group', component: MemberChangeGroup, meta: { label: L.localize('Members_ChangeGroup') } },
      { path: ':id/subscriptions', name: 'member-history', component: MemberSubscriptions, meta: { label: L.localize('Label_Subscriptions') } },
      { path: ':id/audit-logs', name: 'member-audit-logs', component: MemberAuditLogs, meta: { label: L.localize('Label_AuditLogs') } },
      { path: ':id/invoices/:invoiceId', name: 'member-invoice', component: Invoice, meta: { label: L.localize('Label_Invoice') } } ]
  },
  // Groups
  { path: '/app/groups', component: Branch, meta: { label: L.localize('Settings_Group_Index_Title'), icon: 'list' }, children: [
      { path: '', name: 'groups', component: Groups },
      { path: 'create', name: 'group-create', component: Group, meta: { label: L.localize('Label_Create') } },
      { path: ':id', name: 'group', component: Group, meta: { label: L.localize('Settings_Breadcrumb_Details') } },
      { path: ':id/custom-fields', name: 'group-custom-fields', component: GroupCustomFields, meta: { label: L.localize('Label_CustomFields') } },
      { path: ':id/payment-options', name: 'group-payment-options', component: GroupPaymentOptions, meta: { label: L.localize('Label_PaymentOptions') } },
      { path: ':id/import', name: 'import', component: Import, meta: { label: L.localize('Settings_Import_Export_Breadcrumb') } } ]
  },
  // Account
  { path: '/app/account', component: Branch, meta: { label: L.localize('Account_Breadcrumb'), hiddenFromNav: true }, children: [
      { path: '', name: 'account', component: Account },
      { path: 'webhook', name: 'webhook', component: Webhook },

      // Users
      { path: 'users', name: 'users', component: Users },
      { path: 'users/create', name: 'user-create', component: User, meta: { label: L.localize('Label_Create') } },
      { path: 'users/:id', name: 'user', component: User, meta: { label: L.localize('Settings_Breadcrumb_Details') } } ]
  },
  // Membership
  { path: '/app/membership', component: Branch, redirect: { name: 'payment-options' }, meta: { label: L.localize('Membership_Breadcrumb_Index'), icon: 'membership' }, children: [
      //  Payment options
      { path: 'payment-options', name: 'payment-options', component: PaymentOptions },
      { path: 'payment-options/create', name: 'payment-option-create', component: PaymentOption, meta: { label: L.localize('Label_Create') } },
      { path: 'payment-options/:id', name: 'payment-option', component: PaymentOption, meta: { label: L.localize('Settings_Breadcrumb_Details') } },

      // Taxes
      { path: 'taxes', name: 'taxes', component: Taxes },
      { path: 'taxes/create', name: 'tax-create', component: Tax, meta: { label: L.localize('Label_Create') } },
      { path: 'taxes/:id', name: 'tax', component: Tax, meta: { label: L.localize('Settings_Breadcrumb_Details') } },

      // Payment Gateways
      { path: 'payment-gateways', name: 'payment-gateways', component: PaymentGateways, meta: { label: L.localize('Settings_Breadcrumb_Billing') } } ]
  },
  // Campaigns
  { path: '/app/campaigns', component: Branch, meta: { label: L.localize('Campaigns_Breadcrumb_Index'), icon: 'volume' }, children: [
      { path: '', name: 'campaigns', component: Campaigns },
      { path: 'create', name: 'campaign-create', component: Campaign, meta: { label: L.localize('Label_Create') } },
      { path: ':id', name: 'campaign', component: Campaign, meta: { label: L.localize('Settings_Breadcrumb_Details') } },
      { path: ':id/template', name: 'campaign-template', component: Campaign, meta: { label: L.localize('Campaigns_Breadcrumb_Template') } }
  ] },
  // Templates
  { path: '/app/templates', component: Branch, meta: { label: L.localize('Templates_Breadcrumb_Index'), icon: 'mail' }, children: [
      { path: '', name: 'templates', component: Templates },
      { path: 'create', name: 'template-create', component: Template, meta: { label: L.localize('Label_Create') } },
      { path: ':id', name: 'template', component: Template, meta: { label: L.localize('Settings_Breadcrumb_Details') } },
      { path: ':id/editor', name: 'template-editor', component: TemplateEditor, meta: { label: L.localize('Settings_Breadcrumb_Details') } }
  ] }
  // Settings
  // { path: '/app/settings', component: Branch, meta: { label: 'Settings', icon: 'settings' }, children: [
  //     { path: '', name: 'Settings', component: Settings } ]
  // }
]



// WEBPACK FOOTER //
// ./scripts/router/routes.js